'use strict';

exports.__esModule = true;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _httpplease = require('httpplease');

var _httpplease2 = _interopRequireDefault(_httpplease);

var _oldiexdomain = require('httpplease/plugins/oldiexdomain');

var _oldiexdomain2 = _interopRequireDefault(_oldiexdomain);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var http = _httpplease2.default.use(_oldiexdomain2.default);

var Status = {
  PENDING: 'pending',
  LOADING: 'loading',
  LOADED: 'loaded',
  FAILED: 'failed',
  UNSUPPORTED: 'unsupported'
};

var getRequestsByUrl = {};
var loadedIcons = {};

var InlineSVG = function (_React$PureComponent) {
  _inherits(InlineSVG, _React$PureComponent);

  function InlineSVG(props) {
    _classCallCheck(this, InlineSVG);

    var _this = _possibleConstructorReturn(this, (InlineSVG.__proto__ || Object.getPrototypeOf(InlineSVG)).call(this, props));

    _this.handleLoad = function (err, res) {
      var isCached = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var _this$props = _this.props,
          onLoad = _this$props.onLoad,
          src = _this$props.src;

      if (err) {
        _this.fail(err);
        return;
      }

      if (_this.isActive) {
        _this.setState({
          loadedText: res.text,
          status: Status.LOADED
        }, function () {
          onLoad(src, isCached);
        });
      }
    };

    _this.state = {
      status: Status.PENDING
    };

    _this.isActive = false;
    return _this;
  }

  _createClass(InlineSVG, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.isActive = true;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var status = this.state.status;
      var _props = this.props,
          src = _props.src,
          supportTest = _props.supportTest;

      /* istanbul ignore else */

      if (status === Status.PENDING) {
        if (supportTest()) {
          if (src) {
            this.startLoad();
            return;
          }

          this.fail((0, _utils.configurationError)('Missing source'));
          return;
        }

        this.fail((0, _utils.unsupportedBrowserError)());
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var src = this.props.src;


      if (prevProps.src !== src) {
        if (src) {
          this.startLoad();
          return;
        }

        this.fail((0, _utils.configurationError)('Missing source'));
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.isActive = false;
    }
  }, {
    key: 'getFile',
    value: function getFile(callback) {
      var _this2 = this;

      var _props2 = this.props,
          cacheGetRequests = _props2.cacheGetRequests,
          src = _props2.src;


      if (cacheGetRequests) {
        if (loadedIcons[src]) {
          var _loadedIcons$src = _slicedToArray(loadedIcons[src], 2),
              err = _loadedIcons$src[0],
              res = _loadedIcons$src[1];

          callback(err, res, true);
        }

        if (!getRequestsByUrl[src]) {
          getRequestsByUrl[src] = [];

          http.get(src, function (err, res) {
            getRequestsByUrl[src].forEach(function (cb) {
              var currentSrc = _this2.props.src;

              loadedIcons[src] = [err, res];

              if (src === currentSrc) {
                cb(err, res);
              }
            });
          });
        }

        getRequestsByUrl[src].push(callback);
      } else {
        http.get(src, function (err, res) {
          var currentSrc = _this2.props.src;


          if (src === currentSrc) {
            callback(err, res);
          }
        });
      }
    }
  }, {
    key: 'fail',
    value: function fail(error) {
      var onError = this.props.onError;

      var status = error.isUnsupportedBrowserError ? Status.UNSUPPORTED : Status.FAILED;

      /* istanbul ignore else */
      if (this.isActive) {
        this.setState({ status: status }, function () {
          if (typeof onError === 'function') {
            onError(error);
          }
        });
      }
    }
  }, {
    key: 'startLoad',
    value: function startLoad() {
      /* istanbul ignore else */
      if (this.isActive) {
        this.setState({
          status: Status.LOADING
        }, this.load);
      }
    }
  }, {
    key: 'load',
    value: function load() {
      var src = this.props.src;

      var match = src.match(/data:image\/svg[^,]*?(;base64)?,(.*)/);

      if (match) {
        return this.handleLoad(null, {
          text: match[1] ? atob(match[2]) : decodeURIComponent(match[2])
        });
      }

      return this.getFile(this.handleLoad);
    }
  }, {
    key: 'getClassName',
    value: function getClassName() {
      var status = this.state.status;
      var className = this.props.className;

      var nextClassName = 'isvg ' + status;

      if (className) {
        nextClassName += ' ' + className;
      }

      return nextClassName;
    }
  }, {
    key: 'processSVG',
    value: function processSVG(text) {
      var _props3 = this.props,
          uniquifyIDs = _props3.uniquifyIDs,
          uniqueHash = _props3.uniqueHash,
          baseURL = _props3.baseURL,
          processSVG = _props3.processSVG;


      var svgText = text;
      if (processSVG) {
        svgText = processSVG(svgText);
      }

      if (uniquifyIDs) {
        return (0, _utils.uniquifySVGIDs)(svgText, uniqueHash || (0, _utils.randomString)(), baseURL);
      }

      return svgText;
    }
  }, {
    key: 'renderContents',
    value: function renderContents() {
      var status = this.state.status;
      var _props4 = this.props,
          children = _props4.children,
          preloader = _props4.preloader;


      switch (status) {
        case Status.UNSUPPORTED:
        case Status.FAILED:
          return children;
        default:
          return preloader;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var loadedText = this.state.loadedText;
      var _props5 = this.props,
          style = _props5.style,
          wrapper = _props5.wrapper;

      var content = void 0;
      var html = void 0;

      if (loadedText) {
        html = {
          __html: this.processSVG(loadedText)
        };
      } else {
        content = this.renderContents();
      }

      return wrapper({
        style: style,
        className: this.getClassName(),
        dangerouslySetInnerHTML: html
      }, content);
    }
  }]);

  return InlineSVG;
}(_react2.default.PureComponent);

InlineSVG.propTypes = {
  baseURL: _propTypes2.default.string,
  cacheGetRequests: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  onError: _propTypes2.default.func,
  onLoad: _propTypes2.default.func,
  preloader: _propTypes2.default.node,
  processSVG: _propTypes2.default.func,
  src: _propTypes2.default.string.isRequired,
  style: _propTypes2.default.object,
  supportTest: _propTypes2.default.func,
  uniqueHash: _propTypes2.default.string,
  uniquifyIDs: _propTypes2.default.bool,
  wrapper: _propTypes2.default.func
};
InlineSVG.defaultProps = {
  baseURL: '',
  cacheGetRequests: false,
  onLoad: function onLoad() {},
  supportTest: _utils.isSupportedEnvironment,
  uniquifyIDs: true,
  wrapper: _react2.default.createFactory('span')
};
exports.default = InlineSVG;


//////////////////
// WEBPACK FOOTER
// ./~/react-inlinesvg/lib/index.js
// module id = 21
// module chunks = 35783957827783 55213770944713 173894859265406